import { render } from "./BannerImpersonificazione.vue?vue&type=template&id=4678819a"
import script from "./BannerImpersonificazione.vue?vue&type=script&lang=js"
export * from "./BannerImpersonificazione.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__